import NoContentLabel from 'conversations-message-history/atoms/NoContentLabel';
import I18n from 'I18n';
import InlineImageAttachments from '../attachments/components/InlineImageAttachments';
import { getNonImageAttachments, hasImageAttachments
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
} from 'conversations-message-history/attachments/operators/imageAttachmentFilters';
import { hasTextContent } from 'conversations-message-history/web/common-message/operators/hasTextContent';
import { hasIframeContent } from 'conversations-message-history/web/common-message/operators/hasIframeContent';
import ContentText from '../atoms/ContentText';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import { isEmailCMF } from 'conversations-message-history/common-message-format/operators/cmfComparators';
import { getPlainText, getRichText, getSenderType
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
} from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { VISITOR as VISITOR_SENDER } from 'conversations-message-history/common-message-format/constants/legacySenderTypes';
import { PureComponent } from 'react';
import styled from 'styled-components';
import AttachmentsFooter from '../attachments/components/AttachmentsFooter';
import PrimaryMessageContent, { PrimaryMessageContentWrapper } from '../primary-message/components/PrimaryMessageContent';
import PrimaryMessageContentSection from '../primary-message/components/PrimaryMessageContentSection';
import ThemeContext from '../theming/contexts/ThemeContext';
import { darken } from 'visitor-ui-component-library/utils/colors';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'auto... Remove this comment to see the full error message
import autolinker from 'autolinker';
import FormattedMessage from 'I18n/components/FormattedMessage';
import get from 'transmute/get';
import { isPartialMessage } from 'conversations-message-history/partial-message/operators/isPartialMessage';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conversations-message-history/common-message-format/operators/cmfCitationGetters'.
import { getCitations } from 'conversations-message-history/common-message-format/operators/cmfCitationGetters';
import VizExIcon from 'visitor-ui-component-library/icon/VizExIcon';
import SVGWarning from 'visitor-ui-component-library-icons/icons/SVGWarning';
import { CANDY_APPLE } from 'visitor-ui-component-library/constants/WidgetColors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HyperlinkStyleWrapper = styled.div.withConfig({
  displayName: "CommonMessageContent__HyperlinkStyleWrapper"
})(["", " ", " a{color:", ";&:hover{color:", ";}&:active{color:", ";}}"], ({
  speechPocActive
}) => !speechPocActive && 'overflow: hidden;', PrimaryMessageContentWrapper, ({
  hyperlinkColor
}) => hyperlinkColor, ({
  hyperlinkColor
}) => hyperlinkColor && darken(hyperlinkColor), ({
  hyperlinkColor
}) => hyperlinkColor && darken(hyperlinkColor, 0.2));
export const Timestamp = styled.time.withConfig({
  displayName: "CommonMessageContent__Timestamp"
})(["font-size:10px;padding-bottom:4px;margin-top:-4px;"]);
const RejectedWarningIcon = styled.div.withConfig({
  displayName: "CommonMessageContent__RejectedWarningIcon"
})(["position:absolute;left:-26px;top:50%;transform:translateY(-50%);color:", ";"], CANDY_APPLE);
class CommonMessageContent extends PureComponent {
  isSentFromVisitor() {
    return getSenderType(this.props.message) === VISITOR_SENDER;
  }
  isClickableLink(contentText) {
    const linkRegex = new RegExp('([a-zA-Z0-9]+://)?([a-zA-Z0-9_]+:[a-zA-Z0-9_]+@)?([a-zA-Z0-9.-]+\\.[A-Za-z]{2,4})(:[0-9]+)?(/.*)?');
    return linkRegex.test(contentText);
  }
  handleOnClickEvent(event) {
    event.persist();
    if (event.target instanceof HTMLElement && event.target.tagName === 'A') {
      var _this$props$toggleOpe, _this$props;
      (_this$props$toggleOpe = (_this$props = this.props).toggleOpen) === null || _this$props$toggleOpe === void 0 || _this$props$toggleOpe.call(_this$props, {
        isOpened: false,
        isUser: true
      });
    }
  }
  renderContentText() {
    const {
      message,
      mobile,
      isLastMessage,
      senderName,
      navigateToKnowledgeBaseArticle,
      browserWindowHeight
    } = this.props;
    const contentText = getRichText(message) || getPlainText(message);
    const shouldAddOnClickEvent = mobile && this.isClickableLink(contentText);
    if (!contentText) {
      return null;
    }
    const parsedRichText = getRichText(message) && autolinker.link(contentText, {
      stripPrefix: false
    });
    let citations = getCitations(message);
    // If citations is a List, convert it to an array
    // TODO: Handle this better via TS
    if (!Array.isArray(citations)) {
      citations = citations.toJS();
    }
    return /*#__PURE__*/_jsx(ContentText, {
      messageId: message.id,
      contentText: parsedRichText || contentText,
      shouldAnnounce: isLastMessage,
      isPartialMessage: isPartialMessage(message),
      "aria-label": `${this.isSentFromVisitor() ? I18n.text('conversations-visitor-message-history.iSay') : I18n.text('conversations-visitor-message-history.subjectSays', {
        subject: senderName || I18n.text('conversations-visitor-message-history.agent')
      })} ${getPlainText(message)}`,
      onClickAction: shouldAddOnClickEvent ? this.handleOnClickEvent.bind(this) : () => {},
      sources: citations,
      navigateToKnowledgeBaseArticle: navigateToKnowledgeBaseArticle,
      browserWindowHeight: browserWindowHeight
    });
  }
  renderMessageSection() {
    const {
      fileAttachments,
      message
    } = this.props;
    const isMessageHidden = get('hiddenBy', message);
    const shouldRenderInlineAttachments = !isEmailCMF(message) && fileAttachments && hasImageAttachments(fileAttachments);
    const hasContent = hasTextContent(message) || hasIframeContent(message);
    if (isMessageHidden) {
      return /*#__PURE__*/_jsx(PrimaryMessageContentSection, {
        children: /*#__PURE__*/_jsx("i", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-visitor-message-history.common-message.hiddenMessage"
          })
        })
      });
    }
    if (!shouldRenderInlineAttachments && !hasContent) {
      return null;
    }
    return /*#__PURE__*/_jsxs(PrimaryMessageContentSection, {
      children: [this.renderContentText(), shouldRenderInlineAttachments && /*#__PURE__*/_jsx(InlineImageAttachments, {
        fileAttachments: fileAttachments
      }), this.props.quickReplySelect && typeof this.props.quickReplySelect === 'function' && this.props.quickReplySelect(), this.renderTimestampSection()]
    });
  }
  renderAttachmentsSection() {
    const {
      fileAttachments,
      message
    } = this.props;
    const attachments = isEmailCMF(message) ? fileAttachments : getNonImageAttachments(fileAttachments);
    return attachments && attachments.size ? /*#__PURE__*/_jsx(PrimaryMessageContentSection, {
      children: /*#__PURE__*/_jsx(AttachmentsFooter, {
        fileAttachments: attachments
      })
    }) : null;
  }
  renderTimestampSection() {
    const {
      timestamp
    } = this.props;
    if (!timestamp) {
      return null;
    }
    return /*#__PURE__*/_jsx(Timestamp, {
      children: timestamp
    });
  }
  render() {
    const {
      textColor
    } = this.context;
    const messageSection = this.renderMessageSection();
    const attachmentsSection = this.renderAttachmentsSection();
    const sendFromVisitor = this.isSentFromVisitor();
    const {
      hasUnansweredQuickReplyMessage,
      isLastMessage,
      isRejected,
      message,
      playMessageButton,
      speechPocActive = false
    } = this.props;
    return /*#__PURE__*/_jsx(HyperlinkStyleWrapper, {
      hyperlinkColor: sendFromVisitor ? textColor : 'inherit',
      speechPocActive: speechPocActive,
      children: /*#__PURE__*/_jsxs(PrimaryMessageContent, {
        style: isPartialMessage(message) ? {
          background: 'rgb(255,243,238, .3)'
        } : {},
        shouldFocusMessage: isLastMessage && hasUnansweredQuickReplyMessage,
        children: [isRejected && /*#__PURE__*/_jsx(RejectedWarningIcon, {
          children: /*#__PURE__*/_jsx(VizExIcon, {
            icon: /*#__PURE__*/_jsx(SVGWarning, {}),
            size: "sm"
          })
        }), messageSection, attachmentsSection, !messageSection && !attachmentsSection && !isPartialMessage(message) && /*#__PURE__*/_jsx(PrimaryMessageContentSection, {
          children: /*#__PURE__*/_jsx(NoContentLabel, {})
        }), playMessageButton]
      })
    });
  }
}
CommonMessageContent.displayName = 'CommonMessageContent';
CommonMessageContent.contextType = ThemeContext;
export default CommonMessageContent;